/**
 * Get the appliation carbon cost per tonne (this is dependent on the application-pay currency).
 */
import { createSelector } from 'reselect';

import getApplicationSelector from '/business/shared/state/selectors/application/getApplicationSelector';

export default createSelector(
  [getApplicationSelector],
  (application = null) => application?.offset?.carbonCostPerTonneInAppPayCurrency,
);
